/* Adds the currency code after the Kaching Bundles bar prices, e.g. "£22.95" -> "£22.95 GBP".
   Kaching prints Shopify's plain money format and has no option for a code on the page.
   Display only: nothing here changes a price, the cart or checkout. Text that already ends
   in a code (BUCKS writes its own when it converts a price) is left alone, so a code is
   never shown twice. */
(function () {
  var code = window.Shopify && Shopify.currency && Shopify.currency.active;
  if (!code) return;
  var SELECTOR = '.kaching-bundles__bar-price, .kaching-bundles__bar-full-price';
  var HAS_CODE = /\b[A-Z]{3}\s*$/;

  function lastTextNode(el) {
    var walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT);
    var node, last = null;
    while ((node = walker.nextNode())) {
      if (node.nodeValue.trim()) last = node;
    }
    return last;
  }

  function addCodes() {
    document.querySelectorAll(SELECTOR).forEach(function (el) {
      if (HAS_CODE.test(el.textContent)) return;
      var node = lastTextNode(el);
      if (node) node.nodeValue = node.nodeValue.replace(/\s+$/, '') + ' ' + code;
    });
  }

  // Kaching draws and redraws the bars after page load
  var queued = false;
  new MutationObserver(function () {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () {
      queued = false;
      addCodes();
    });
  }).observe(document.documentElement, { subtree: true, childList: true, characterData: true });
  addCodes();
})();
